import { LICENSED_PRODUCTS } from '@atlassian/jira-common-util-get-tenant-context';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { AiEnablementResponse } from './types';

export const fetchAiEnablementUrl = (JIRA_SERVICEDESK: string): string =>
	`/rest/latest/aiconfig/optin/${JIRA_SERVICEDESK}`;

export const fetchAiEnablement = (): Promise<AiEnablementResponse> => {
	const { JIRA_SERVICEDESK } = LICENSED_PRODUCTS;
	const url = fetchAiEnablementUrl(JIRA_SERVICEDESK);
	return fetchJson(url, {
		method: 'GET',
	});
};
